import { skipToken } from '@reduxjs/toolkit/query';
import Loader from 'components/Loader';
import { RecordPage } from 'components/record-header/RecordHeader';
import { SectionEditProvider } from 'components/section-edit/SectionEdit';
import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useParams } from 'react-router-dom';
import { useGetExperienceRecordByIdQuery } from 'store/api/experience-records.ts';
import { useHasPermissions } from 'utils/permissionUtil';
import ExperienceRecordPageHeader from './ExperienceRecordPageHeader.tsx';
import GeneralView from './views/GeneralView.tsx';

const ExperienceRecordPage = () => {
    const { id: experienceRecordId } = useParams();
    const isNew = useIsNewDesign();
    // The edit form's Save gate.
    const canUpdate = useHasPermissions(['UPDATE.EXPERIENCE_RECORDS.ALL']);

    const { data: xr, isLoading } = useGetExperienceRecordByIdQuery(experienceRecordId ?? skipToken);

    if (isLoading) {
        return <Loader />;
    }

    if (xr && isNew) {
        // No tabs: the band ends under the header, and the cards scroll below it.
        return (
            <RecordPage header={<ExperienceRecordPageHeader experienceRecord={xr} />} tabbed={false}>
                <SectionEditProvider canEdit={canUpdate}>
                    <GeneralView experienceRecord={xr} />
                </SectionEditProvider>
            </RecordPage>
        );
    }

    return (
        <PaddedLayout>
            {xr && (
                <>
                    <ExperienceRecordPageHeader experienceRecord={xr} />
                    <GeneralView experienceRecord={xr} />
                </>
            )}
        </PaddedLayout>
    );
};

export default ExperienceRecordPage;
